import { useEffect, useState } from "react";
import { subscribeApiLoading } from "../utilities/apiLoadingManager";

export default function useApiLoading() {
  const [state, setState] = useState({
    pendingCount: 0,
    isLoading: false,
    context: null,
  });

  useEffect(() => subscribeApiLoading(setState), []);

  return state;
}
